import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoadbookDownloadInfo } from '../../models/roadbookDownloadInfo.model';
import { Roadbook } from '../../models/roadbook.model';
import { Observable } from 'rxjs';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { RoadbookDownloadInfoService } from '../../services/roadbook-download-info.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { RoadbookOption } from '../../models/roadbookOption.model';
import { PrestashopService } from '../../services/prestashop.service';
import { map } from 'rxjs/operators';
import { EventRoadService } from '../../services/eventRoad.service';

@Component({
  selector: 'app-users-detail-page',
  templateUrl: './users-detail-page.component.html',
  styleUrls: ['./users-detail-page.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class UsersDetailPageComponent implements OnInit {
  id: string;

  panelOpenState = false;
  expandedElement: RoadbookDownloadInfo | null;
  displayedColumns: string[] = ['star', 'roadbook_id', 'device_name' ];
  dataSource: MatTableDataSource<RoadbookDownloadInfo>;
  filteredUsers: Observable<any>;
  roadbooksWeb: RoadbookOption[];
  filteredRoadbooks: Observable<any>;
  // roadbook_id: string;
  // orderline_id: string;
  // device_id: string;
  // device_name: string;
  // download_date: Date;
  roadbookInfo: RoadbookDownloadInfo[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private router: ActivatedRoute,
    private _rds: EventRoadService,
    private _rs: RoadbookDownloadInfoService,
    private _pss: PrestashopService) {
    this.router.params.subscribe( params => {
      this.id = params['id'];
    });
    // this.filteredRoadbooks = this._pss.getVirtualProducts().pipe(map((value, idx) => {
    //   return value.map(vi =>  new RoadbookOption(vi.id, vi.name[0].value));
    // }));
   }

  ngOnInit() {
    this.filteredRoadbooks = this._rds.getAll().pipe(map(v => {
      return v.map(vi => {
        if (vi.roadbook_type === 1) {
          return new RoadbookOption(vi.code, vi.name);
        } else {
          return new RoadbookOption(vi.code, vi.name);
        }
      });
    }));
    this.filteredRoadbooks.subscribe(value => {
      this.roadbooksWeb = value;
      this._rs.getRoadbooks(this.id).subscribe(data => {
        this.roadbookInfo = data;
        // Assign the data to the data source for the table to render
        this.dataSource = new MatTableDataSource(this.roadbookInfo);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  removeElemet(element) {
    this._rs.remove(this.id, element);
  }
  getRoadbookName(id) {
    const o = this.roadbooksWeb.find(rw => rw.id.toString() === id.toString());
    return (o) ? o.name : '';
  }
}
